import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  questions: [],
};

const QuesRed = createSlice({
  name: "QuesRed",
  initialState,
  reducers: {
    addQues: (state, action) => {
      console.log("addQues called",action);
      state.questions.push(action.payload);
      console.log("Updated state.questions", state.questions);
    },
  },
});

export const { addQues } = QuesRed.actions;
export default QuesRed.reducer;
